import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { SubscribeButton } from "../../User";
import { ProfileAvatar } from "../ProfileAvatar";
import { ActionsRow } from "./ActionsRow";
import { UserInfoContent } from "./UserInfoContent";
import { Button } from "@parkschannel/ui";
import classNames from "classnames";
export const UserPublicInfo = (param)=>{
    let { user  } = param;
    return /*#__PURE__*/ _jsxs("section", {
        className: "relative p-4 bg-white rounded-2xl w-full max-w-[1126px] mx-auto mb-10 md:mb-7 md:flex md:items-center md:gap-6 md:px-6 md:py-8 lg:gap-10 lg:mb-16",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "absolute left-1/2 -translate-x-1/2 -top-[85px] w-fit md:static md:translate-x-0 ",
                children: /*#__PURE__*/ _jsx(ProfileAvatar, {
                    src: user.avatar_key
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: " w-full grid mt-[80px] md:mt-0",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "mx-auto md:absolute md:top-6 md:right-6 lg:top-8 lg:right-8",
                        children: /*#__PURE__*/ _jsx(ActionsRow, {
                            user: user
                        })
                    }),
                    /*#__PURE__*/ _jsx(UserInfoContent, {
                        user: user,
                        subscribeButton: /*#__PURE__*/ _jsx(SubscribeButton, {
                            button: (param)=>/*#__PURE__*/ {
                                let { subscribe , isSubscribed , isLoading  } = param;
                                return _jsx(Button, {
                                    disabled: isLoading,
                                    variant: isSubscribed ? "base" : "outline",
                                    onClick: ()=>subscribe(user.cognito_id),
                                    className: classNames({
                                        "bg-neutral-100": isSubscribed
                                    }, "!drop-shadow h-[40px] flex items-center !px-4 text-[14px]"),
                                    children: isSubscribed ? "Subscribed" : "Subscribe"
                                });
                            },
                            isSubscribed: user.isSubscribed,
                            accountId: user.cognito_id,
                            className: "!drop-shadow h-[40px] flex items-center !px-4 text-[14px]"
                        })
                    })
                ]
            })
        ]
    });
};
